// extracted by mini-css-extract-plugin
export default {"countInTitle":"TableSummary_countInTitle__D-Bny"};